import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "FasePage",
    data() {
        let ss = new MainService();
        return {
            msg: "FasePage",
            ss: ss,
            ajax: {
                "url": ss.indexFase(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Fase', name: 'Fase', title: 'Fase' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            fases: [],
            fase: {},
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newFase() {
            this.fase = {};
            this.$refs['frm-fase'].show();
        },
        showFase(id) {
            this.isLoading=true;
            this.ss.showFase(id).then(
                (result) => {
                    let response = result.data;
                    this.fase = response.data;
                    this.$refs['view-fase'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editFase() {
            this.$refs['frm-fase'].show();
            this.$refs['view-fase'].hide();
        },
        cancelFase() {
            if (this.fase.id) {
                this.$refs['view-fase'].show();
            }
            this.$refs['frm-fase'].hide();
        },
        saveFase() {
            this.ss.storeFase(this.fase).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-fase'].hide();
                    this.$refs['datatable-fase'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteFase() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                        this.ss.destroyFase(this.fase)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-fase'].hide();
                                this.$refs['datatable-fase'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Fase').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showFase(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }else{
            this.auth = usuario;
        }
    }
};
